import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useForm } from 'react-hook-form'
import useErrorHandler from 'data/hooks/useErrorHandler'
import { useMutation } from 'react-query'
import { useNotifier } from 'react-headless-notifier'
import ApiClient from 'data/api/api_client'
import PublicModal from 'components/PublicModal'
import { CheckCircleIcon } from 'components/icons'
import Input from 'components/form/Input'
import Button from 'components/Button'
import Notification from 'components/Notification'
import LogoLink from './logoLink'
import StatusPanel from './StatusPanel'

const InviteFriendsModal = ({ isOpen, onClose = () => { } }) => {
  const handleError = useErrorHandler()
  const { notify } = useNotifier()

  const [showConfirmation, setShowConfirmation] = useState(false)

  const { handleSubmit, register, setError, reset, formState: { errors }, getValues } = useForm()

  const inviteUser = useMutation(
    (details) => ApiClient.users.inviteFriend(details),
    {
      onSuccess: () => {
        setShowConfirmation(true)
      },
      onError: (error) => {
        if (error.response.status !== 422) {
          notify(
            <Notification message="There was an issue inviting this user, please try again" type="error" />,
          )
        }
        handleError(error, setError)
      },
    },
  )

  const handleOnClose = () => {
    reset()
    onClose()
    setShowConfirmation(false)
  }

  return (
    <PublicModal
      isOpen={isOpen}
      onClose={handleOnClose}
      className="!max-w-[452px]"
    >
      {
        showConfirmation
          ? <div className="h-full flex flex-col justify-center items-center text-center mt-[148px] mb-[248px]">
            <StatusPanel
              icon={<CheckCircleIcon />}
              title="Invitation Sent"
              description={`${getValues('name')} will receive an invitation email shortly!`}
            />
          </div>
          :          <>
            <div className="flex justify-center">
              <LogoLink className="text-white w-[128px] h-[70px]" />
            </div>
            <div className="mt-[31px] font-bold text-16 leading-24 -tracking-1/2 text-grey-875 flex justify-center">
              Invite your friends to join us
            </div>
            <div className="text-center antialiased font-normal text-14 text-grey-500 mb-[43px] mt-15 -tracking-1/2 leading-24">
              If they book with us, you will automatically receive a 500€ loyalty credit. This will be applied towards your next booking with us.
            </div>
            <form onSubmit={handleSubmit(inviteUser.mutate)}>
              <p className="mb-5 mt-25">Name:</p>
              <Input className="h-60" {...register('name')} error={errors?.name?.message} style="customer" />
              <p className="mb-5 mt-25">Email:</p>
              <Input className="h-60" {...register('email')} error={errors?.email?.message} style="customer" />
              <Button
                type="submit"
                className="w-full mt-50 mb-40 h-[60px] uppercase"
                isLoading={inviteUser.isLoading && !inviteUser.isError}
              >
                Send Invite
              </Button>
            </form></>
      }

    </PublicModal>
  )
}

InviteFriendsModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
}

export default InviteFriendsModal
